/**
 * @module data/constants
 */

// defaults inputs
export var DEFAULT_ANNUAL_INCOME = 100000;
export var DEFAULT_CREDIT_SCORE = 690;
export var DEFAULT_DTI = 0.36;
export var DEFAULT_HOA = 0;
export var DEFAULT_INTERST_RATE = 0.04125;
export var DEFAULT_LOAN_TERM = 30;
export var DEFAULT_MONTHLY_DEBT = 0;
export var DEFAULT_SUGGESTED_PURCHASE_PRICE = 500000;

/**
 * The maximum credit score to use FHA loans
 */
export var MAX_FHA_CREDIT_SCORE = 629;

/**
 * Minimum loan amount to trigger error scenario
 */
export var MIN_LOAN_AMOUNT = 30000;

/**
 * Minimum down payment percent for conventional loans, used to calculate minimum out of pocket costs
 */
export var MIN_PERCENT_DOWN_CONVENTIONAL = 0.03;

/**
 * Minimum down payment percent for FHA loans, used to calculate minimum out of pocket costs
 */
export var MIN_PERCENT_DOWN_FHA = 0.035;

/**
 * Minimum DTI to test if we create a loan that has mortgage insurance, but is above 20% down payment
 */
export var MIN_DTI = 0.3;

/**
 * How much to adjust DTI when attempting to find loan
 */
export var DTI_ADJUSTMENT = 0.001;

/**
 * The percent of down payment that will require mortgage insurance
 */
export var DOWN_PAYMENT_PERCENT_INSURANCE = 0.2;

/**
 * Percent down payment we recommend
 */
export var RECOMMENDED_DOWN_PAYMENT_PERCENT = 0.2;

/**
 * Assumed effective tax rate
 */
export var TAX_RATE = 0.32;

/**
 * Multipler for upfront FHA mortgage insurance premium.
 * Upfront Mortgage Insurance Premium (UFMIP) should be
 * 175 Basis Points (bps) (1.75%) of the Base Loan Amount
 * @see https://www.hud.gov/program_offices/housing/comp/premiums/annual_mip Appendix 1.0
 */
export var UPFRONT_FHA_MIP = 0.0175;

/**
 * Credit report fee is an upfrontRequiredServices
 */
export var UPFRONT_CREDIT_REPORT_FEE = 17;